import { createContext, useContext } from 'react';
import type { CellulaTexts } from '../../utils/hooks/use_text';

interface CellulaI18nProviderContext {
	texts?: CellulaTexts;
}

export const CellulaI18nProviderContext = createContext<CellulaI18nProviderContext>(
	undefined as unknown as CellulaI18nProviderContext,
);

export function useCellulaI18nProviderContext(): CellulaI18nProviderContext {
	const cellulaI18nProviderContext = useContext(CellulaI18nProviderContext);
	if (cellulaI18nProviderContext === undefined) {
		throw new Error('useCellulaI18nProviderContext must be used within a CellulaI18nProvider');
	}

	return cellulaI18nProviderContext;
}
